import { Link } from 'react-router-dom';

/**
 * Componente Menu Hamburguesa reutilizable
 * @param {boolean} isOpen - Estado del menú
 * @param {Function} onToggle - Callback para abrir/cerrar
 * @param {Array} items - Array de { label, href, onClick }
 * @param {string} className - Clases adicionales
 * @param {string} overlayClassName - Clases para el overlay
 * @param {string} menuClassName - Clases para el panel del menú
 */
function HamburgerMenu({
  isOpen = false,
  onToggle,
  items = [],
  className = '',
  overlayClassName = '',
  menuClassName = '',
}) {
  return (
    <div className={`relative ${className}`}>
      {/* Botón hamburguesa */}
      <button
        onClick={onToggle}
        className="p-2 rounded-md hover:bg-gray-100 transition-colors"
        aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
        aria-expanded={isOpen}
      >
        <div className="w-6 h-5 flex flex-col justify-between">
          <span
            className={`block h-0.5 w-full bg-gray-700 opacity-70 rounded transition-transform ${
              isOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          />
          <span
            className={`block h-0.5 w-full bg-gray-700 opacity-70  rounded transition-opacity ${
              isOpen ? 'opacity-0' : ''
            }`}
          />
          <span
            className={`block h-0.5 w-full bg-gray-700 opacity-70  rounded transition-transform ${
              isOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          />
        </div>
      </button>

      {/* Overlay - gris oscuro semi-transparente */}
      {isOpen && (
        <div
          className={`fixed inset-0 bg-gray-900/70 backdrop-blur-sm z-40 ${overlayClassName}`}
          onClick={onToggle}
          aria-hidden="true"
        />
      )}

      {/* Panel del menú - gris oscuro semi-transparente */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-gray-800/95 backdrop-blur-md shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } ${menuClassName}`}
      >
        <div className="p-4 pt-16">
          {items.map((item, idx) => (
            <div key={idx} className="border-b border-white/10 last:border-0">
              {item.href ? (
                item.href.startsWith('/') ? (
                  <Link
                    to={item.href}
                    onClick={() => {
                      item.onClick?.();
                      onToggle?.();
                    }}
                    className="block py-3 px-2 text-white hover:bg-white/10 rounded-md transition-colors"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    href={item.href}
                    onClick={() => {
                      item.onClick?.();
                      onToggle?.();
                    }}
                    className="block py-3 px-2 text-white hover:bg-white/10 rounded-md transition-colors"
                  >
                    {item.label}
                  </a>
                )
              ) : (
                <button
                  onClick={() => {
                    item.onClick?.();
                    onToggle?.();
                  }}
                  className="block w-full text-left py-3 px-2 text-white hover:bg-white/10 rounded-md transition-colors"
                >
                  {item.label}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HamburgerMenu;
